// libraries
import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import { ConfigProvider } from 'antd';
import locale from 'antd/lib/locale/da_DK';
import 'antd/dist/antd.min.css';

import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/da';

import AOS from 'aos';
import 'aos/dist/aos.css';

import '@fontsource-variable/raleway';
import '@fontsource-variable/oswald';

// oplev alt fonts
import '@fontsource-variable/montserrat';
import '@fontsource/poppins';
import '@fontsource/poppins/700.css';

// components
import { Router } from './components/navigation';
import { GlobalStyle } from './global-style';

// utilities
import * as serviceWorkerRegistration from './utils/service-worker/serviceWorkerRegistration';
import reportWebVitals from './utils/reportWebVitals';
import * as AuthService from './services/bb-api/auth';

moment.tz.setDefault('Europe/Copenhagen');

(async function renderApp() {
	AOS.init();

	if (localStorage.getItem('bb_user_id') !== null) {
		try {
			await AuthService.getAuthorization();
		} catch (error) {
			window.location.href = '/login';
		}
	}

	ReactDOM.render(
		<React.StrictMode>
			<ConfigProvider locale={locale}>
				<RecoilRoot>
					<Router />
					<GlobalStyle />
				</RecoilRoot>
			</ConfigProvider>
		</React.StrictMode>,
		document.getElementById('root')
	);
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
